import { Box } from "@chakra-ui/react";
import { getIsInDetachMode } from "src/duck/selectors";
import { useSelector } from "react-redux";
import { getAppValue } from "src/utils/environment";
import { useParentStation } from "src/modules/parent-station/ParentStation/Context";

const responsivePadding = "1.9085vmin";
const responsiveMargin = "3.0534vmin";
// const responsivePadding = ["10px", "14px", "16px"];
// const responsiveMargin = ["16px", "20px", "24px"];

const tilesResponsivePadding = ["8px", "10px", "14px"];
const tilesResponsiveMargin = ["14px", "16px", "20px"];

const getColor = ({ isActive, station, colorFirstTwoDots, id, mode }) => {
  const getParentStationActiveColor = () => {
    if (mode === "video") {
      return "warningBase";
    } else {
      return "white";
    }
  };

  const getBabyStationActiveColor = () => {
    if ((colorFirstTwoDots && id === 1) || (colorFirstTwoDots && id === 2)) {
      return getAppValue({
        barkio: "primary",
        bibino: "secondary"
      });
    } else {
      return "warningBase";
    }
  };

  if (station === "parent") {
    if (isActive) {
      return getParentStationActiveColor();
    } else {
      return "black20";
    }
  }
  if (station === "baby") {
    if (isActive) {
      return getBabyStationActiveColor();
    } else {
      return "black20";
    }
  }
};

export default function PureIndicator({ station, responsive, isActive, colorFirstTwoDots, id, mode }) {
  const parentStation = useParentStation();
  const isInDetachMode = useSelector(getIsInDetachMode);

  const { showTilesView = null } = parentStation || {};
  const isInTileView = showTilesView && station === "parent";
  const useDetachStyle = isInDetachMode && station === "parent";
  return (
    <Box
      p={responsive ? (isInTileView ? tilesResponsivePadding : responsivePadding) : "8px"}
      mr={responsive ? (isInTileView ? tilesResponsiveMargin : responsiveMargin) : "13px"}
      bg={getColor({ isActive, station, colorFirstTwoDots, id, mode })}
      borderRadius=" 100%"
      sx={{
        ":last-of-type": {
          mr: "0px"
        }
      }}
      {...(useDetachStyle && {
        p: "3vmin !important",
        mr: "4.5vmin !important",
        sx: {
          ":last-of-type": {
            mr: "0px !important"
          }
        }
      })}
    />
  );
}
